var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("list-item", {
    attrs: {
      link: { name: "requests.show", params: { id: _vm.booking.id } },
      booking: _vm.booking,
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [
            _vm._v("\n    " + _vm._s(_vm.booking.name) + " – "),
            _c("span", { staticClass: "text-primary" }, [
              _vm._v(
                _vm._s(
                  _vm._f("currency")(
                    _vm.booking.budget_per_star_as_user_rate,
                    _vm.booking.currency
                  )
                )
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "admin",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
      {
        key: "hero",
        fn: function () {
          return [_vm._v("Respond")]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }